import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css"; // Ensure your styles are applied

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.email || !formData.password) {
        setError("All fields are required!");
        return;
    }

    try {
        const response = await fetch("https://api.irfanelectricals.com/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || "Login failed!");
        }

        // ✅ Check if userId exists in response
        if (!data.userId) {
            throw new Error("User ID is missing from response.");
        }

        // ✅ Store userId & token in localStorage
        localStorage.setItem("userId", data.userId); 
        localStorage.setItem("token", data.token);

        console.log("Stored User ID:", localStorage.getItem("userId")); // Debugging

        navigate("/profile"); // Redirect after login
        window.location.reload(); // Refresh to reflect login status

    } catch (error) {
        setError(error.message || "An error occurred.");
    }
};

  

  return (
    <div className="login-container d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="card shadow-lg p-4 rounded" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="text-center">
          <h2 className="fw-bold text-primary">Irfan Electricals</h2>
          <p className="text-muted">Login to your account</p>
        </div>

        {error && <div className="alert alert-danger p-2">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="rememberMe" />
              <label className="form-check-label" htmlFor="rememberMe">Remember Me</label>
            </div>
            <Link to="/forgot-password" className="text-decoration-none text-primary">Forgot Password?</Link>
          </div>

          <button type="submit" className="btn btn-primary w-100 fw-bold" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="mt-3 text-center">
          Don't have an account? <Link to="/register" className="text-primary">Register</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
